export const editSettings = {
    allowEditing: true,
    allowAdding: true,
    allowDeleting: true,
    showConfirmDialog: true,
    mode: "Dialog",
    headerTemplate: "Ayrıntılar"
  };
  
  export default editSettings;